<template>
  <div>
    <van-popup
      v-model="isClose"
      position="right"
      :style="{ height: '100%',width:'100%',background: '#f5f5f5' }"
    >
      <div>
        <van-nav-bar>
          <div slot="title">详情</div>
          <div slot="right" @click="close">关闭</div>
        </van-nav-bar>
        <div>
          <div class="detail-title">
            <p class="detail-name nowrap">
              <span>{{child.StudentName}}</span>
              <span class="detail-split">&nbsp;|&nbsp;</span>
              <span class="nowrap detail-username">{{child.UserName}}</span>
            </p>
            <p class="detail-class">{{child.ClassName}}</p>
          </div>
          <div class="detail-cont">
            <div class="detail-cont-title">我的想法</div>
            <div class="word-all">{{child.Idea}}</div>
          </div>
          <div class="detail-cont">
            <div class="detail-cont-title">希望得到的帮助</div>
            <div class="word-all">{{child.Wish}}</div>
          </div>
          <div class="detail-cont">
            <div class="detail-cont-title">兴趣爱好</div>
            <div class="word-all">{{child.Interest}}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "MyStudentDetails",
  props: {
    isClose: Boolean,
    row: Object
  },
  watch: {
    isClose(newVal) {
      if (newVal) {
        this.getInfo();
      }
    }
  },
  data() {
    return {
      child: {}
    };
  },
  methods: {
    close() {
      this.$emit("listenToClose", false);
    },
    async getInfo() {
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/MyStudent/GetStudentInfo`,
        {
          sessionID: this.row.sessionID,
          studentID: this.row.studentID,
          publishID: this.row.publishID
        }
      );
      if (res.success) {
        this.child = res.data;
      }
      this.xy.unloading();
    }
  }
};
</script>
<style lang="less" scoped>
.detail-title {
  background: #fff;
  margin-bottom: 20px;
  padding: 20px 20px 20px 30px;
  min-height: 140px;
  .detail-name {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 30px;
    .detail-split {
      color: #ccc;
      font-size: 24px;
    }
    .detail-username {
      font-size: 28px;
    }
  }
  .detail-class {
    margin-top: 20px;
  }
}
.detail-cont {
  min-height: 300px;
  margin: 0 20px 20px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  .detail-cont-title {
    font-size: 30px;
    border-bottom: 1px dashed #eee;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
}
</style>
